import { render, staticRenderFns } from "./PhoneUpload.vue?vue&type=template&id=e8ed0312&scoped=true"
import script from "./PhoneUpload.vue?vue&type=script&lang=js"
export * from "./PhoneUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ed0312",
  null
  
)

export default component.exports